import React, { CSSProperties } from "react";

function Center({ children, style }: { children: any; style: CSSProperties }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: "14px",
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export default Center;
